export namespace CacheKeyConstants {
  export const CURRENT_USER = 'currentUser';
  export const CURRENT_USER_AUTH_DATA = 'currentUserAuthData';
  export const PERMISSIONS = 'permissions';
  export const RESERVATION_STATUSES = 'reservationStatuses';
  // TODO: Rename CLARA_RULE_VALUES
  export const RULE_VALUES = 'ruleValues';
  export const DOTS_RULE_VALUES = 'dotsRuleValues';
  export const DEACTIVATION_REASONS = 'deactivationReasons';
  export const TRANSIT_PROGRAMS = 'transitPrograms';
  export const ORGANIZATIONS = 'organizations';
  export const VEHICLE_TYPES = 'vehicleTypes';
  export const CARD_TYPES = 'cardTypes';
  export const PAYMENT_METHODS = 'paymentMethods';
  export const CANCELLATION_REASONS = 'cancellationReasons';
  export const STATES = 'states';
  export const COUNTRIES = 'countries';
  export const AMENITIES = 'amenities';
  export const ACTIVE_RESERVATION = 'activeReservation';
  export const DRIVER_DOCUMENT_TYPES = 'driverDocumentTypes';
  export const TNC_DRIVER_PROFILE = 'tncDriverProfile';
  export const LYFT_DISPATCH_RIDE_STATUSES = 'lyftDispatchRideStatuses';
  export const CURRENT_USER_ROLES = 'currentUserRoles';
  export const DISMISSED_BANNERS = 'dismissedBanners';
  export const OPEN_TABS = 'openTabs';

  // Keep this list updated with keys that should be cleared on logout
  export const clearableCachedValues = [
    PERMISSIONS,
    RESERVATION_STATUSES,
    RULE_VALUES,
    DOTS_RULE_VALUES,
    DEACTIVATION_REASONS,
    TRANSIT_PROGRAMS,
    ORGANIZATIONS,
    VEHICLE_TYPES,
    CARD_TYPES,
    PAYMENT_METHODS,
    CANCELLATION_REASONS,
    STATES,
    COUNTRIES,
    AMENITIES,
    ACTIVE_RESERVATION,
    DRIVER_DOCUMENT_TYPES,
    LYFT_DISPATCH_RIDE_STATUSES,
    CURRENT_USER_ROLES,
    OPEN_TABS
  ];

  export function clearClearableValues(): void {
    clearableCachedValues.forEach(item => {
      localStorage.removeItem(item);
    });
  }
}
